type ApiFetchOptions = RequestInit & {
    userId?: number;
    restaurantSlug?: string;
};

const API_BASE = "/api";

export async function apiFetch(
    path: string,
    opts: ApiFetchOptions = {}
) {
    const { userId, restaurantSlug, headers, method = "GET", body, ...options } = opts;

    const finalHeaders: Record<string, string> = {
        ...(headers ? (headers as Record<string, string>) : {}),
    };

    if (body && !finalHeaders["Content-Type"]) {
        finalHeaders["Content-Type"] = "application/json";
    }

    if (userId !== undefined) {
        finalHeaders["X-User-Id"] = String(userId);
    }

    if (restaurantSlug) {
        finalHeaders["X-Restaurant"] = restaurantSlug;
    }

    return fetch(API_BASE + path, {
        method,
        headers: finalHeaders,
        body,
        cache: "no-store",
        credentials: "include",
        ...options,
    });
}
